import React, { Component, Fragment } from 'react';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import Table from '../lib';

import todos from './todos';

export default class Editable extends Component {
  state = {
    rows: todos,
    selected: null,
    horizontal: false
  };

  cols = [
    {
      prop: 'title',
      label: 'Title',
      editor: (value, row, col) => (
        <TextField
          autoFocus
          fullWidth
          onChange={e => this.update(e.target.value, row, col)}
          value={value}
        />
      )
    },
    {
      prop: 'done',
      label: 'Status',
      render: prop => (prop ? 'Completed' : 'Pending'),
      editor: (value, row, col) => (
        <Checkbox
          autoFocus
          checked={value}
          onChange={(e, checked) => this.update(checked, row, col)}
        />
      )
    }
  ];

  cellProps = {
    vertical: {
      onClick: e =>
        this.setState({
          selected: {
            row: e.target.parentNode.rowIndex - 1,
            col: e.target.cellIndex
          }
        })
    },
    horizontal: {
      onClick: e =>
        this.setState({
          selected: {
            row: e.target.cellIndex - 1,
            col: e.target.parentNode.rowIndex
          }
        })
    }
  };

  update = (newValue, row, col) => {
    const newRows = this.state.rows;
    newRows[row][this.cols[col].prop] = newValue;
    this.setState({ rows: newRows });
  };

  toggleHorizontal = () =>
    this.setState({ horizontal: !this.state.horizontal });

  closeEditor = () => this.setState({ selected: null });

  render() {
    const selectedCol = this.state.selected && this.state.selected.col;
    const selectedRow = this.state.selected && this.state.selected.row;

    return (
      <Fragment>
        <Typography
          variant="title"
          gutterBottom
          style={{ marginTop: 40, color: '#fff' }}>
          Editable
        </Typography>

        <Paper
          square
          style={{
            marginBottom: 20,
            boxShadow: '8px 8px 0 rgba(0, 0, 0, 0.1)'
          }}>
          {!this.state.horizontal && (
            <Table
              cellProps={this.cellProps.vertical}
              cols={this.cols}
              rows={this.state.rows}
              selectedCol={selectedCol}
              selectedRow={selectedRow}
            />
          )}

          {this.state.horizontal && (
            <Table
              cellProps={this.cellProps.horizontal}
              cols={this.cols}
              horizontal
              rows={[this.state.rows[0]]}
              selectedCol={selectedCol}
              selectedRow={selectedRow}
            />
          )}
        </Paper>

        <Button onClick={this.toggleHorizontal}>Toggle horizontal</Button>

        <Button
          onClick={this.closeEditor}
          disabled={
            (!selectedCol && selectedCol !== 0) ||
            (!selectedRow && selectedRow !== 0)
          }>
          Close editor
        </Button>

        <div style={{ marginBottom: 40 }} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/examples/Editable.js